import { render, staticRenderFns } from "./DeviceParameterItem.vue?vue&type=template&id=0084434c&scoped=true&"
import script from "./DeviceParameterItem.vue?vue&type=script&lang=js&"
export * from "./DeviceParameterItem.vue?vue&type=script&lang=js&"
import style0 from "./DeviceParameterItem.vue?vue&type=style&index=0&id=0084434c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084434c",
  null
  
)

export default component.exports